var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iot-LargeDataScreen"},[_c('div',{staticClass:"iot-LargeDataScreen-title"},[_c('div',{staticClass:"time"},[_vm._v(" "+_vm._s(_vm.timeNow)+" ")]),_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.platform.platformName)+" ")]),_c('div',{staticClass:"btn",on:{"click":_vm.goHome}},[_vm._v(" 控制台 ")])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }